import React from 'react';

const Superendividamento = () => {
    return (
        <div className='container-calculo'>
            <div className='label-calculo'>
                <h1 className='titulo-calculo'>Superendividamento</h1>
            </div>
        </div>
    );
};

export default Superendividamento;